import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _87d52a4a = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _6e85ce13 = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _d57d8f94 = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _cb9099b0 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _8cd62070 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _7da4baa4 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _54978eec = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _61990672 = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _4d1c83e0 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _758a76b1 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _7aadca76 = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _d29ab72a = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _91a7ff1e = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _50c228c8 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _67511d40 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _2c0a5f2b = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _ac42f15c = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _3705a9f0 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _52485453 = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _538ba3b3 = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _cff9789c = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _74876cea = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _7772d61e = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _0c6884e2 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _249f42d6 = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _63bb01b0 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _8f03741c = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _a8c86be0 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _cc260524 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _8decf98c = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _52227971 = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _21241d7c = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _02260f4d = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _15fead85 = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _7f01cff2 = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _40bc957d = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _00c9c350 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _abe582b4 = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _1ef77058 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _b26cced0 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _7748e8d0 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _d62a9db8 = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _701959ca = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _3d990e72 = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _c6d5e416 = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _0b6b26c1 = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _2650286b = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _9a50c7f6 = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _a903e166 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _10849fc7 = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _9b7416e4 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _633d3154 = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _83e4486e = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _29deb73b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _ddf7af24 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _092de653 = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _5d6eb2a0 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _4a4d862f = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _316c56d4 = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _2dbae4c1 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _5ba77cb6 = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _5695df10 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _129980f5 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _dc1765a6 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _7f8cd6c0 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _07b32ffa = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _790bd01e = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _a4e6ecb8 = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _78a777a0 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _b10ff710 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _64d90a6d = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _9173d03e = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _a1a44f16 = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _c2fcceba = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _6a445ab5 = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _0ce4c593 = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _87d52a4a,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _6e85ce13,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _d57d8f94,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _cb9099b0,
    name: "calendar"
  }, {
    path: "/customer",
    component: _8cd62070,
    name: "customer"
  }, {
    path: "/details",
    component: _7da4baa4,
    name: "details"
  }, {
    path: "/goals",
    component: _54978eec,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _61990672,
    name: "maisoku"
  }, {
    path: "/media",
    component: _4d1c83e0,
    name: "media"
  }, {
    path: "/privacy",
    component: _758a76b1,
    name: "privacy"
  }, {
    path: "/project",
    component: _7aadca76,
    name: "project"
  }, {
    path: "/response",
    component: _d29ab72a,
    name: "response"
  }, {
    path: "/sale",
    component: _91a7ff1e,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _50c228c8,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _67511d40,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _2c0a5f2b,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _ac42f15c,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _3705a9f0,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _52485453,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _538ba3b3,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _cff9789c,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _74876cea,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _7772d61e,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _0c6884e2,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _249f42d6,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _63bb01b0,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _8f03741c,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _a8c86be0,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _cc260524,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _8decf98c,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _52227971,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _21241d7c,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _02260f4d,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _15fead85,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _7f01cff2,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _40bc957d,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _00c9c350,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _abe582b4,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _1ef77058,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _b26cced0,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _7748e8d0,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _d62a9db8,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _701959ca,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _3d990e72,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _c6d5e416,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _0b6b26c1,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _2650286b,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _9a50c7f6,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _a903e166,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _10849fc7,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _9b7416e4,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _633d3154,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _83e4486e,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _29deb73b,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _ddf7af24,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _092de653,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _5d6eb2a0,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _4a4d862f,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _316c56d4,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _2dbae4c1,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _5ba77cb6,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _5695df10,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _129980f5,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _dc1765a6,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _7f8cd6c0,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _07b32ffa,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _790bd01e,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _a4e6ecb8,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _78a777a0,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _b10ff710,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _64d90a6d,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _9173d03e,
    name: "property-property",
    children: [{
      path: "contact",
      component: _a1a44f16,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _c2fcceba,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _6a445ab5,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _0ce4c593,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
